<template>
  <div class="faultmanagement-container">
    <el-form :model="queryInfo" size="medium" :inline="true">
          <el-form-item :label="$t('finance.name39')" prop="tenantId">
              <el-cascader ref="refHandle" v-model="tenantIds"  :show-all-levels="false" @change="handleChange" :props="{ lazy: true, lazyLoad: loadOptions, checkStrictly: true }" clearable></el-cascader>
          </el-form-item>
          <el-form-item :label="$t('bike.name65')" prop="ebikeId">
            <el-input v-model="queryInfo.ebikeId" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <!-- <el-form-item :label="$t('bike.name66')" prop="cycleId">
            <el-input v-model="queryInfo.cycleId" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item> -->
          <el-form-item :label="$t('bike.name68')" prop="faultCode">
            <el-select v-model="queryInfo.faultCode" :placeholder="$t('public.name1')" clearable>
              <el-option v-for="item in faultTypeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('bike.name69')" prop="faultTime">
            <el-date-picker
            v-model="faultTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :range-separator="$t('public.name9')"
            :start-placeholder="$t('public.name10')"
            :end-placeholder="$t('public.name11')"
          >
          </el-date-picker>
          </el-form-item>
          <el-form-item >
          <el-button type="primary" size="medium" @click="getPageList">{{ $t('public.name3') }}</el-button>
          <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
          </el-form-item>
    </el-form>
    <el-table :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading='tableLoading'>
      <el-table-column :label="$t('bike.name38')" prop="ebikeId" sortable></el-table-column>
      <el-table-column :label="$t('finance.name40')" prop="tenantName" sortable> </el-table-column>
      <!-- <el-table-column :label="$t('bike.name70')" prop="cycleId" sortable></el-table-column> -->
      <el-table-column :label="$t('bike.name71')" prop="faultType" sortable></el-table-column>
      <!-- <el-table-column :label="$t('bike.name72')" prop="faultStatus" sortable>
        <template slot-scope="scope">
         <div>
           {{ ['故障','正常'][scope.row.faultStatus] }}
         </div>
        </template>
      </el-table-column> -->
      <el-table-column :label="$t('bike.name73')" prop="faultTime" sortable></el-table-column>
      <el-table-column :label="$t('bike.name11')" width="100px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="showDetailsDialog(scope.row)">{{ $t('bike.name46') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
    <!--故障详情-->
    <el-dialog :title="$t('bike.name74')" :visible.sync="detailsDialog" v-if="detailsDialog" :close-on-click-modal ="false" :before-close="close" width="800px">
      <el-row class="row-style1">
        <el-col :span="8" class="col-style margin10">
          {{ $t('bike.name38') }}
        </el-col>
        <el-col :span="8" class="col-style margin10">
          {{ $t('bike.name29') }}
        </el-col>
        <el-col :span="8" class="margin10">
          {{ $t('bike.name71') }}
        </el-col>
      </el-row>
      <el-row class="row-style2">
        <el-col :span="8" class="col-style margin10">
          {{ faultDetails.ebikeId }}
        </el-col>
        <el-col :span="8" class="col-style margin10">
          {{ faultDetails.faultTime }}
        </el-col>
        <el-col :span="8" class="margin10">
          {{ faultDetails.faultType }}
        </el-col>
      </el-row>
      <!-- <el-row class="row-style1">
        <el-col :span="8" class="col-style margin10">
          {{ $t('bike.name75') }}
        </el-col>
        <el-col :span="8" class="col-style margin10">
          {{ $t('bike.name29') }}
        </el-col>
        <el-col :span="8" class="margin10">
          {{ $t('bike.name72') }}
        </el-col>
      </el-row> -->
      <!-- <el-row class="row-style2">
        <el-col :span="8" class="col-style margin10">
          {{ faultDetails.userId }}
        </el-col>
        <el-col :span="8" class="col-style margin10">
          {{ faultDetails.faultTime }}
        </el-col>
        <el-col :span="8" class="margin10">
          {{ faultDetails.faultStatus }}
        </el-col>
      </el-row> -->

      <!-- <el-row class="row-style1">
        <el-col :span="8" class="col-style margin10">
          {{ $t('bike.name76') }}
        </el-col>
        <el-col :span="8" class="col-style margin10">
          {{ $t('bike.name77') }}
        </el-col>
        <el-col :span="8" class="margin10">
          {{ $t('bike.name78') }}
        </el-col>
      </el-row> -->
      <!-- <el-row class="row-style2">
        <el-col :span="8" class="col-style margin10">
        </el-col>
        <el-col :span="8" class="col-style margin10">
        </el-col>
        <el-col :span="8" class="margin10">
        </el-col>
      </el-row> -->

      <!-- <el-row class="row-style1">
        <el-col :span="24" class="margin10">
          {{ $t('bike.name79') }}
        </el-col>
      </el-row>
      <el-row class="row-style2">
        <el-col :span="24" class="margin10">
          {{ faultDetails.faultDesc }}
        </el-col>
      </el-row> -->

      <!-- <el-row class="row-style1">
        <el-col :span="24" class="margin10">
          {{ $t('bike.name80') }}
        </el-col>
      </el-row> -->
      <el-row class="row-style3">
        <el-col :span="24" class="margin10">
          <MapComPonents :itemdata="faultDetails" />
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
// import Cookies from 'js-cookie'
// import axios from 'axios'
import { tenantList } from '@/api/manage.js'
import { findFaultPage } from '@/api/bike.js'
import MapComPonents from './mapComPonents.vue'
export default {
  data() {
    return {
      tenantIds: [],
      detailsDialog: false,
      queryInfo: {
        pageNumber: 1,
        pageSize: 10,
        tenantId: '',
        ebikeId: '',
        cycleId: '',
        faultCode: '',
        startTime: '',
        endTime: '',
        faultStatus: ''

      },
      faultTypeList: [
        {
          value: '01',
          label: this.$t('bike.name420')
        },
        {
          value: '02',
          label: this.$t('bike.name421')
        },
        {
          value: '03',
          label: this.$t('bike.name422')
        },
        {
          value: '04',
          label: this.$t('bike.name423')
        },
        {
          value: '05',
          label: this.$t('bike.name424')
        },
        {
          value: '06',
          label: this.$t('bike.name425')
        },
        {
          value: '07',
          label: this.$t('bike.name426')
        },
        {
          value: '08',
          label: this.$t('bike.name427')
        },
        {
          value: '09',
          label: this.$t('bike.name428')
        },
        {
          value: '10',
          label: this.$t('bike.name429')
        },
        {
          value: '11',
          label: this.$t('bike.name430')
        },
        {
          value: '12',
          label: this.$t('bike.name431')
        },
        {
          value: '13',
          label: this.$t('bike.name432')
        },
        {
          value: '14',
          label: this.$t('bike.name433')
        },
        {
          value: '15',
          label: this.$t('bike.name434')
        },
        {
          value: '16',
          label: this.$t('bike.name435')
        },
        {
          value: '17',
          label: this.$t('bike.name436')
        },
        {
          value: '18',
          label: this.$t('bike.name437')
        },
        {
          value: '30',
          label: this.$t('bike.name438')
        }
      ],
      faultTime: [],
      total: 0,
      tenantOptions: [],
      tableList: [],
      srcList: [],
      faultDetails: {},
      tableLoading: false,
      statusOptions: [
        {
          value: '',
          label: this.$t('public.name19')
        },
        {
          value: '0',
          label: this.$t('bike.name113')
        },
        {
          value: '1',
          label: this.$t('bike.name228')
        }
      ]
    }
  },
  components: {
    MapComPonents
  },
  created() {
    this.getTenantList()
  },
  mounted() {
    this.getFaultList()
    this.getTenantList()
  },
  computed: {},
  methods: {

    resetQuery() {
      this.queryInfo = {
        pageNumber: 1,
        pageSize: 10,
        tenantId: '',
        ebikeId: '',
        cycleId: '',
        faultCode: '',
        faultTime: '',
        faultStatus: ''
      }
      this.faultTime = []
      this.tenantIds = []
      this.getFaultList()
    },
    getPageList() {
      this.queryInfo.pageNumber = 1
      this.queryInfo.pageSize = 10
      this.getFaultList()
    },
    getFaultList() {
      this.tableLoading = true
      if (this.faultTime) {
        this.queryInfo.startTime = this.faultTime[0]
        this.queryInfo.endTime = this.faultTime[1]
      } else {
        this.queryInfo.startTime = ''
        this.queryInfo.endTime = ''
      }
      findFaultPage(this.queryInfo).then(res => {
        this.tableLoading = false
        if (res.code === 200) {
          this.tableList = res.data.faultPage.records
          this.tableList.map((item) => {
            this.faultTypeList.map((items) => {
              if (item.faultCode + '' === items.value + '') {
                item.faultType = items.label
              }
            })
          })
          this.total = res.data.faultPage.total
        }
      })
    },
    getTenantList() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 2
      }
      tenantList(data)
        .then(res => {
          this.tenantOptions = res.data.list
        })
        .catch(() => {
          this.tenantOptions = []
        })
    },
    showDetailsDialog(row) {
      this.faultDetails = row
      this.srcList.push(this.faultDetails.faultAddr)
      this.detailsDialog = true
    },
    close() {
      this.detailsDialog = false
    },
    loadOptions(node, resolve) {
      if (node.level === 2) {
        resolve([])
        return
      }
      let data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }

      if (node.level === 1) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 2,
          parentId: node.value
        }
      }

      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName,
              leaf: node.level >= 1
            }))
            resolve(options)
          } else {
            resolve([])
          }
        })
        .catch(() => {})
    },
    handleChange(value) {
      // 处理选项变化
      this.queryInfo.tenantId = value[value.length - 1]
      const panelRefs = this.$refs.refHandle.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },
    // 监听pagesizes的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.getFaultList()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.pageNumber = newPage
      this.getFaultList()
    }
  }
}
</script>
<!-- <style lang="scss">
.el-dialog__body {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
</style> -->

<style lang="scss" scoped>
.faultmanagement-container {
  display: flex;
  flex-direction: column;

  .row-style1 {
    border: 1px solid #dcdddd;
    border-bottom: none;
    height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
    background: #f5f5f5;
  }
  .row-style2 {
    border: 1px solid #dcdddd;
    border-bottom: none;
    height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
  }

  .row-style3 {
    border: 1px solid #dcdddd;
    height: 430px;
    width: 100%;
    display: flex;
    align-items: center;
  }
  .col-style {
    border-right: 1px solid #dcdddd;
    height: 40px;
    display: flex;
    align-items: center;
  }
  .margin10 {
    padding-left: 10px;
  }
  .green {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #ebf6ed;
    color: #39ab4c;
  }

  .red {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #fcecec;
    color: #ea4646;
  }
}
</style>
